module.exports = __webpack_public_path__ + "media/psfm.6264e60c.mp4";